'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_IMAGE_SUCCESS = exports.SAVE_IMAGE_SUCCESS = exports.SAVE_SUCCESS = exports.ORGANIZATION_LOAD_SUCCESS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;
exports.changeFilter = changeFilter;
exports.destroy = destroy;
exports.getOrganization = getOrganization;
exports.isLoaded = isLoaded;
exports.isLoading = isLoading;
exports.load = load;
exports.newOrganization = newOrganization;
exports.removeErrors = removeErrors;
exports.restore = restore;
exports.save = save;
exports.saveImage = saveImage;
exports.deleteImage = deleteImage;
exports.search = search;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHANGE_FILTER = 'caligram/organizations/CHANGE_FILTER';
var DESTROY = 'caligram/organizations/DESTROY';
var DESTROY_SUCCESS = 'caligram/organizations/DESTROY_SUCCESS';
var DESTROY_FAIL = 'caligram/organizations/DESTROY_FAIL';
var LOAD = 'caligram/organizations/LOAD';
var LOAD_FAIL = 'caligram/organizations/LOAD_FAIL';
var LOAD_SUCCESS = 'caligram/organizations/LOAD_SUCCESS';
var ORGANIZATION_LOAD_FAIL = 'caligram/organizations/ORGANIZATION_LOAD_FAIL';
var ORGANIZATION_LOAD_SUCCESS = exports.ORGANIZATION_LOAD_SUCCESS = 'caligram/organizations/ORGANIZATION_LOAD_SUCCESS';
var ORGANIZATION_NEW = 'caligram/organizations/ORGANIZATION_NEW';
var REMOVE_ERRORS = 'caligram/organizations/REMOVE_ERRORS';
var RESTORE = 'caligram/organizations/RESTORE';
var RESTORE_SUCCESS = 'caligram/organizations/RESTORE_SUCCESS';
var RESTORE_FAIL = 'caligram/organizations/RESTORE_FAIL';
var SAVE = 'caligram/organizations/SAVE';
var SAVE_FAIL = 'caligram/organizations/SAVE_FAIL';
var SAVE_SUCCESS = exports.SAVE_SUCCESS = 'caligram/organizations/SAVE_SUCCESS';
var SAVE_IMAGE = 'caligram/organizations/SAVE_IMAGE';
var SAVE_IMAGE_FAIL = 'caligram/organizations/SAVE_IMAGE_FAIL';
var SAVE_IMAGE_SUCCESS = exports.SAVE_IMAGE_SUCCESS = 'caligram/organizations/SAVE_IMAGE_SUCCESS';
var DELETE_IMAGE = 'caligram/organizations/DELETE_IMAGE';
var DELETE_IMAGE_FAIL = 'caligram/organizations/DELETE_IMAGE_FAIL';
var DELETE_IMAGE_SUCCESS = exports.DELETE_IMAGE_SUCCESS = 'caligram/organizations/DELETE_IMAGE_SUCCESS';
var SEARCH = 'caligram/organizations/SEARCH';
var SEARCH_FAIL = 'caligram/organizations/SEARCH_FAIL';
var SEARCH_SUCCESS = 'caligram/organizations/SEARCH_SUCCESS';

var initialState = {
  loaded: false,
  loading: false,
  organizations: {
    data: [],
    meta: {}
  },
  organization: {
    logo: null,
    name: null,
    slug: null,
    description: '',
    contact_name: null,
    contact_email: null,
    contact_phone: null,
    contact_url: null
  },
  promise: null,
  queryParams: {
    direction: 'desc',
    order: 'creation',
    page: 1,
    q: '',
    parents: ''
  },
  saveError: {},
  saving: false,
  search: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  function decrementTotal() {
    var meta = state.organizations.meta;
    meta.pagination.total = meta.pagination.total - 1;
    return meta;
  }

  function destroyedOrganization(id) {
    var index = 0;
    var organizations = state.organizations.data;

    for (index = 0; index < organizations.length; index++) {
      if (organizations[index].id === id) {
        return organizations.splice(index, 1)[0];
      }
    }
    return null;
  }

  function incrementTotal() {
    var meta = state.organizations.meta;
    meta.pagination.total = meta.pagination.total + 1;
    return meta;
  }

  function restoreOrganization() {
    var destroyed = state.destroyed;
    var organizations = state.organizations.data;

    organizations.unshift(destroyed);

    return organizations;
  }

  switch (action.type) {
    case CHANGE_FILTER:
      return (0, _extends5.default)({}, state, {
        queryParams: action.newFilter
      });
    case DESTROY:
      return (0, _extends5.default)({}, state, {
        loading: true
      });
    case DESTROY_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false,
        error: action.error
      });
    case DESTROY_SUCCESS:
      return (0, _extends5.default)({}, state, {
        destroyed: destroyedOrganization(action.id),
        organizations: {
          data: state.organizations.data,
          meta: decrementTotal()
        },
        loading: false
      });
    case LOAD:
      return (0, _extends5.default)({}, state, {
        loading: true,
        loaded: false
      });
    case LOAD_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: false,
        organizations: null,
        error: action.error
      });
    case LOAD_SUCCESS:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: true,
        organizations: action.result,
        error: null
      });
    case ORGANIZATION_LOAD_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: false,
        organization: null,
        error: action.error
      });
    case ORGANIZATION_LOAD_SUCCESS:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: true,
        organization: action.result,
        error: null
      });
    case ORGANIZATION_NEW:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: true,
        organization: initialState.organization,
        error: null
      });
    case REMOVE_ERRORS:
      return (0, _extends5.default)({}, state, {
        saveError: {}
      });
    case RESTORE:
      return (0, _extends5.default)({}, state, {
        loading: true
      });
    case RESTORE_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false
      });
    case RESTORE_SUCCESS:
      return (0, _extends5.default)({}, state, {
        destroyed: null,
        organizations: {
          data: restoreOrganization(),
          meta: incrementTotal()
        },
        loading: false
      });
    case SAVE:
      return (0, _extends5.default)({}, state, {
        saving: true
      });
    case SAVE_FAIL:
      return (0, _extends5.default)({}, state, {
        saving: false,
        saveError: (0, _extends5.default)({}, state.saveError, (0, _defineProperty3.default)({}, action.id || 'new', action.error))
      });
    case SAVE_SUCCESS:
      return (0, _extends5.default)({}, state, {
        saving: false,
        saveError: (0, _extends5.default)({}, state.saveError, (0, _defineProperty3.default)({}, action.id, null))
      });
    case SEARCH:
      if (state.promise && state.promise.cancel) {
        state.promise.cancel();
      }

      return (0, _extends5.default)({}, state, {
        loading: true,
        promise: action.promise
      });
    case SEARCH_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error,
        promise: null
      });
    case SEARCH_SUCCESS:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: true,
        search: action.result,
        promise: null
      });
    default:
      return state;
  }
}

function changeFilter(newFilter) {
  return { type: CHANGE_FILTER, newFilter: newFilter };
}

function destroy(id) {
  return {
    types: [DESTROY, DESTROY_SUCCESS, DESTROY_FAIL],
    id: id,
    promise: function promise(client) {
      return client.del('/organizations/' + id);
    }
  };
}

function getOrganization(id) {
  if (id) {
    return {
      types: [LOAD, ORGANIZATION_LOAD_SUCCESS, ORGANIZATION_LOAD_FAIL],
      promise: function promise(client) {
        return client.get('/organizations/' + id + '?include=users,inheritedUsers');
      }
    };
  }
}

function isLoaded(globalState) {
  return globalState.organizations && globalState.organizations.loaded;
}

function isLoading(globalState) {
  return globalState.organizations && globalState.organizations.loading;
}

function load(queryString) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/organizations?' + _queryString2.default.stringify(queryString));
    }
  };
}

function newOrganization() {
  return {
    type: ORGANIZATION_NEW
  };
}

function removeErrors() {
  return {
    type: REMOVE_ERRORS
  };
}

function restore(id) {
  return {
    types: [RESTORE, RESTORE_SUCCESS, RESTORE_FAIL],
    id: id,
    promise: function promise(client) {
      return client.put('/organizations/' + id + '/restore');
    }
  };
}

function save(organization) {
  var promise = void 0;
  if (organization.id) {
    promise = function promise(client) {
      return client.put('/organizations/' + organization.id, {
        data: organization
      });
    };
  } else {
    promise = function promise(client) {
      return client.post('/organizations', {
        data: organization
      });
    };
  }
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    id: organization.id,
    promise: promise
  };
}

function saveImage(image) {
  return {
    types: [SAVE_IMAGE, SAVE_IMAGE_SUCCESS, SAVE_IMAGE_FAIL],
    promise: function promise(client) {
      return client.post('/images?type=organization', {
        image: image
      });
    }
  };
}

function deleteImage(id) {
  return {
    types: [DELETE_IMAGE, DELETE_IMAGE_SUCCESS, DELETE_IMAGE_FAIL],
    promise: function promise(client) {
      return client.del('/images/' + id + '?type=organization');
    }
  };
}

function search(input) {
  return {
    types: [SEARCH, SEARCH_SUCCESS, SEARCH_FAIL],
    promise: function promise(client) {
      return client.get('/organizations?' + _queryString2.default.stringify({ q: input }));
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/organizations.js
// module id = 262
// module chunks = 0